<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="contents"><a id="page_8"></a><a id="page_9"></a><em>Contents</em></h2>
<p class="toc"><a href="#/xhtml/intro#intro">Introduction</a></p>
<p class="toc"><a href="#/xhtml/ch1#ch1">Chapter 1:   The Beginning</a></p>
<p class="toc"><a href="#/xhtml/ch2#ch2">Chapter 2:   The World of UFOs</a></p>
<p class="toc"><span href="#/xhtml/ch3#ch3" title="Link target outside of Sample">Chapter 3:   The Other Witnesses</span></p>
<p class="toc"><span href="#/xhtml/ch4#ch4" title="Link target outside of Sample">Chapter 4:   The Investigation</span></p>
<p class="toc"><span href="#/xhtml/ch5#ch5" title="Link target outside of Sample">Chapter 5:   Other New Mexico UFO Reports</span></p>
<p class="toc"><span href="#/xhtml/ch6#ch6" title="Link target outside of Sample">Chapter 6:   Other “Unidentified” Occupant Sightings</span></p>
<p class="toc"><span href="#/xhtml/ch7#ch7" title="Link target outside of Sample">Chapter 7:   Psychological Solutions</span></p>
<p class="toc"><span href="#/xhtml/ch8#ch8" title="Link target outside of Sample">Chapter 8:   UFO Symbols</span></p>
<p class="toc"><span href="#/xhtml/ch9#ch9" title="Link target outside of Sample">Chapter 9:   What Symbol Did Zamora See?</span></p>
<p class="toc"><span href="#/xhtml/ch10#ch10" title="Link target outside of Sample">Chapter 10: Socorro as a Hoax</span></p>
<p class="toc"><span href="#/xhtml/ch11#ch11" title="Link target outside of Sample">Chapter 11: Other Landings</span></p>
<p class="toc"><span href="#/xhtml/ch12#ch12" title="Link target outside of Sample">Chapter 12: Project Blue Book and Socorro</span></p>
<p class="toc"><span href="#/xhtml/ch13#ch13" title="Link target outside of Sample">Chapter 13: Physical Evidence</span></p>
<p class="toc"><span href="#/xhtml/conclusion#conclusion" title="Link target outside of Sample">Conclusions</span></p>
<p class="toc"><span href="#/xhtml/notes#notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/xhtml/bib#bib" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/xhtml/index#index" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?6f98cca9